import { render, staticRenderFns } from "./ActualSyndicShutter.vue?vue&type=template&id=35b1b04f&"
import script from "./ActualSyndicShutter.vue?vue&type=script&lang=js&"
export * from "./ActualSyndicShutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports